// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"RM-z","carouselContainer":"SM-z"};